<template>
    <header class="admin-page__header">
        <!-- Só aparece abaixo de 992px (ver admin.css): abre a gaveta de navegação. -->
        <button type="button" class="admin-page__menu-btn" @click="abrirMenu" aria-label="Abrir menu"
            :aria-expanded="String(layout.mobileOpen)">
            <i class="ri-menu-line"></i>
        </button>

        <div class="admin-page__titles">
            <h1 class="admin-page__title" :title="title">{{ title }}</h1>
            <p v-if="subtitle" class="admin-page__subtitle" :title="subtitle">{{ subtitle }}</p>
        </div>

        <div v-if="$slots.actions" class="admin-page__actions">
            <slot name="actions"></slot>
        </div>
    </header>
</template>

<script>
import { adminLayoutState, abrirSidebarMobile } from './adminLayoutState';

/**
 * Cabeçalho padrão das páginas do admin: título, subtítulo e ações à direita.
 *
 * As ações (o "+ Adicionar …" de cada tela) entram pelo slot `actions`, para
 * ficarem sempre no mesmo lugar em todas as páginas.
 */
export default {
    name: "HeaderPage",
    props: {
        title: {
            type: String
        },
        subtitle: {
            type: String
        }
    },
    setup() {
        return { layout: adminLayoutState };
    },
    methods: {
        abrirMenu() {
            abrirSidebarMobile();
        },
    },
}
</script>
